declare type Library = "core" | "maps" | "places" | "geocoding" | "routes" | "marker" | "geometry" | "elevation" | "streetView" | "journeySharing" | "drawing" | "visualization";
interface IGoogleMapConfig {
    apiKey: string;
    libraries: Library[];
}
const config: IGoogleMapConfig = {
    apiKey: "AIzaSyCRmMwKd-w0npT42cmINtK0csazF1CKM-g",
    // apiKey: "AIzaSyCdBvXBuyBr2HD8Sk2m72Dw8nmubIHaiHw", // FOR LOCAL DEVELOPMENT
    libraries: ["places", "marker"]
};
export default config;